var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSelectPic(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "80px",
    height: "80px",
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "tupian") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "3.4\\uFF08Nubis\\u7A7A\\u95F4\\u3001\\u914D\\u7F6E\\uFF09",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u65B0\\u5EFA\\u914D\\u7F6E\\u6A21\\u677F--\\u58C1\\u7EB8\\u914D\\u7F6E",
    transform: "translate(-805.000000, -534.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "tupian",
    transform: "translate(805.000000, 534.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    stroke: "#979797",
    fill: "#D8D8D8",
    opacity: 0,
    x: 0.5,
    y: 0.5,
    width: 79,
    height: 79
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,23.2825638 C0,15.3857017 6.57158641,8.98876404 14.677342,8.98876404 L53.8123548,8.98876404 C61.9181104,8.98876404 68.4896968,15.3857017 68.4896968,23.2825638 L68.4896968,49.4867218 C68.4896968,57.3835838 61.9181104,63.7805215 53.8123548,63.7805215 L14.677342,63.7805215 C6.57158641,63.7805215 0,57.3835838 0,49.4867218 L0,23.2825638 Z",
    id: "\\u8DEF\\u5F84",
    fill: "#DCF5F6",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2288353,39.9563804 C12.2288353,47.1924588 18.2527549,53.0584594 25.6836363,53.0584594 C33.1145176,53.0584594 39.1384372,47.1924588 39.1384372,39.9563804 C39.1384372,32.720302 33.1145176,26.8543014 25.6836363,26.8543014 C18.2527549,26.8543014 12.2288353,32.720302 12.2288353,39.9563804 Z",
    id: "\\u8DEF\\u5F84",
    fill: "#04BABE",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8398515,20.2553192 C51.388751,19.5177219 50.5864123,19.0679229 49.7218076,19.0679229 C48.8572029,19.0679229 48.0548642,19.5177219 47.6037637,20.2553192 L32.8236872,45.1855688 C32.3725867,45.9231661 31.570248,46.372965 30.7056433,46.372965 C29.8410386,46.372965 29.0386999,45.9231661 28.5875994,45.1855688 L25.4507713,39.8981642 C25.0034621,39.1554119 24.1997722,38.7012401 23.3327275,38.7012401 C22.4656827,38.7012401 21.6619929,39.1554119 21.2146836,39.8981642 L6.52364361,64.674312 C5.58533477,66.256424 6.76335757,68.2460497 8.64682424,68.2460497 L17.0881794,68.2460497 C18.4374264,68.2460497 19.5195636,69.533656 20.6496436,70.2493733 C21.0263369,70.4890873 21.4783689,70.6294912 21.9783437,70.6294912 L77.461847,70.6294912 C79.3453137,70.6294912 80.5233365,68.64329 79.5816031,67.0577534 L51.8398515,20.2553192 Z",
    id: "\\u8DEF\\u5F84",
    fill: "#B4EBED",
    fillRule: "nonzero"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectPic);
export default __webpack_public_path__ + "static/media/select_pic.9286d11ef0625ceaf0d1c3475f566ff1.svg";
export { ForwardRef as ReactComponent };